import React from 'react'
import { inject, observer } from 'mobx-react'
import { CreateProduct, CreateChildProduct } from '../ProductStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { AsyncBarcodeSearchInput } from '../../../../../components/Input/AsyncSearch/AsyncBarcodeSearchInput'
import TextArea from 'antd/lib/input/TextArea'
import { ResponsiveRow } from '../../../../../components/ResponsiveContainer/ResponsiveRow'
import { ColProps } from 'antd/lib/grid'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  product: CreateProduct | CreateChildProduct
}

@inject('currentCompanyStore')
@observer
export class BarcodeTab extends React.Component<Props, {}> {
  render() {
    const company = this.props.currentCompanyStore!.company!
    const { product } = this.props
    const rowProps = { style: { marginBottom: 16 } }
    const labelColProps: ColProps = { md: 24, lg: 8 }
    const contentColProps: ColProps = { md: 24, lg: 16 }

    const disabled =
      product instanceof CreateProduct ? product.isDeleted : product.parentProduct.isDeleted

    return (
      <div
        style={{
          minHeight: '406px', // this is required due to internal issues with antd, can't change overflow settings on <Tab />
        }}
      >
        <ResponsiveRow
          labelText={
            <div>
              <strong>Barcode</strong>
              <div className='text-muted'>Will scan on the POS</div>
            </div>
          }
          rowProps={rowProps}
          labelColProps={labelColProps}
          contentColProps={contentColProps}
        >
          <AsyncBarcodeSearchInput
            size='default'
            companyId={company.id}
            productId={product.id}
            productChanged={product.changed}
            barcode={product.barcode || ''}
            disabled={disabled}
            onChange={(barcode) => product.setBarcode(barcode)}
            generateBarcode={() => product.generateBarcode()}
          />
        </ResponsiveRow>

        <ResponsiveRow
          labelText={
            <div>
              <strong>Barcode product label</strong>
              <div className='text-muted'>Optional, defaults to product name</div>
            </div>
          }
          rowProps={rowProps}
          labelColProps={labelColProps}
          contentColProps={contentColProps}
        >
          <TextArea
            value={product.shortName}
            disabled={disabled}
            onChange={(e) => product.setShortName(e.target.value)}
          />
        </ResponsiveRow>
      </div>
    )
  }
}
